import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  useToast,
} from '@chakra-ui/react';
import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { z } from 'zod';

import { SimpleForm } from './SimpleForm';
import { SimpleTagsInput } from './SimpleTagsInput';
import { trpc } from '../config/trpc';

type FormValues = {
  emails: string[];
};

const schema = z.object({
  emails: z.array(z.string().email()).min(1, 'Please add at least one email address to invite.'),
});

export const InviteContactsModal = ({ disclosure }) => {
  const toast = useToast();
  const { mutateAsync: createAccountInvites, isLoading: isSubmitting } = trpc.createAccountInvites.useMutation();

  const methods = useForm<FormValues>({
    mode: 'onSubmit',
    resolver: zodResolver(schema),
    defaultValues: {
      emails: [],
    },
  });

  const handleSubmit = async (values: FormValues) => {
    try {
      await createAccountInvites(values);
      disclosure.onClose();
      methods.reset();
      toast({
        title: 'Success',
        description: 'Invites sent successfully',
        status: 'success',
      });
    } catch (error) {
      toast({
        title: 'Something went wrong',
        description: error.message,
        status: 'error',
      });
    }
  };

  return (
    <Modal isCentered {...disclosure}>
      <ModalOverlay />
      <ModalContent w="750px" maxW="none">
        <ModalHeader>
          <Text>Invite Users</Text>
          <Text fontSize="sm" fontWeight="normal">
            Your account will be linked to your colleagues so please invite them to work on shipments together.
          </Text>
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <SimpleForm {...(methods as any)} onSubmit={handleSubmit}>
            <SimpleTagsInput name="emails" placeholder="Ex. jack@example.com, jill@example.com" />
            <ModalFooter pr={0} gap={2}>
              <Button size="lg" colorScheme="gray" onClick={disclosure.onClose}>
                Cancel
              </Button>
              <Button size="lg" colorScheme="primary" type="submit" isLoading={isSubmitting}>
                Send Invites
              </Button>
            </ModalFooter>
          </SimpleForm>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
